import styled, { useTheme } from 'styled-components';
import { isMobile, isMobileOrTablet, isTablet, WithBreakpointRange } from '@mews-commander/ui';
import { Container, getToken, withBreakpointRange, WithChildren } from '@optimus-web/core';
import { CardCustom } from '../CardCustom';

const CardCustomStyled = styled(CardCustom)`
    overflow: hidden;
`;

const RepaymentPlanLayoutComponent: React.FC<WithBreakpointRange & WithChildren> = ({ children, breakpointRange }) => {
    const theme = useTheme();

    return (
        <Container
            padding={['0', (isMobile(breakpointRange) && '200') || (isTablet(breakpointRange) && '300') || '900']}
        >
            <CardCustomStyled
                vertical
                alignment="center"
                paddingHorizontal={(isMobileOrTablet(breakpointRange) && '200') || '500'}
                paddingVertical={(isMobile(breakpointRange) && '300') || '900'}
                background={getToken('paletteBrandNight25')({ theme })}
                spacing="300"
            >
                {children}
            </CardCustomStyled>
        </Container>
    );
};

export const RepaymentPlanLayout = withBreakpointRange(RepaymentPlanLayoutComponent);
